<template>
  <div class="card margin-bottom-m"  :style="{ 'border-color': color,'width': '100%'}">
    <ul>
      <li v-for="item in foods" v-bind:key="item.food_id">{{item.food_name}} ({{item.amount}} g.)</li>
    </ul>
    <div ref="circle" class="circle" :style="{ backgroundColor: color }"/>
  </div>
</template>

<script>
export default {
  name: 'MealCardColor',
  props: {
    foods: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: '#ffffff'
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables";

.card {
  border: 2px solid $primary;
  border-radius: 1em;
  padding: 1em 1em 1em 1em;
  margin: 1%;
}

.circle {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/MealCardColor.vue